import { type ReactNode } from "react";
import FooterComponent from "./footer";
import Navigation from "./navigation";
import ScrollProgress from "./ScrollProgress";

type SiteLayoutProps = {
  children: ReactNode;
};

const SiteLayout = ({ children }: SiteLayoutProps) => (
  <div className="site-shell">
    <ScrollProgress />
    <a className="skip-link" href="#main">Skip to content</a>
    <Navigation />
    <main id="main">{children}</main>
    <FooterComponent />
  </div>
);

export default SiteLayout;
